<template>
  <cv-modal class="content-modal" v-bind="$attrs" :class="cssClass">
    <slot v-for="slot in Object.keys($slots)" :name="slot" />
    <template v-for="slot in Object.keys($slots)" v-slot:[slot]="slotData">
      <slot :name="slot" v-bind="slotData || {}" />
    </template>
  </cv-modal>
</template>

<script setup lang="ts">
//https://gist.github.com/loilo/73c55ed04917ecf5d682ec70a2a1b8e2
import { computed } from "vue";

interface Props {
  showHeader?: boolean;
  showClose?: boolean;
  disableClose?: boolean;
  fullScreen?: boolean;
}

const {
  showHeader = true,
  showClose = true,
  disableClose = false,
  fullScreen = false,
} = defineProps<Props>();

const cssClass = computed(() => ({
  "_hide-header": !showHeader,
  "_hide-close": !showClose,
  "_disable-close": disableClose,
  fullscreen: fullScreen,
}));
</script>
<style lang="scss">
.content-modal {
  .student-list {
    list-style: auto inside;
  }

  &._disable-close {
    .bx--modal-close {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
</style>
